export default {
    beforeUpdate(el, binding) {
        const value = binding.value;
        if (value) {
            el.classList.add('disabled');
        }
        else {
            el.classList.remove('disabled');
        }
    },
};
